import { isInView } from "./utils"

const scrollCart = {

cartLine: document.getElementById('addToCartLine'),
cartBtn: document.querySelector('.jsInView') as HTMLElement | undefined,


init() {
    window.addEventListener('scroll', () => {
        
   
        this.setScroll();
        this.reset();
    })

    
}, 

reset() {
window.addEventListener('reset', () => {
    this.cartLine?.classList.remove('activeClass');
})
},

setScroll() {
    
    if(isInView(this.cartBtn)) {
         
         this.cartLine?.classList.add('activeClass')
   
    } else {
        
    
        this.cartLine?.classList.remove('activeClass')
        
    }
},




}

export default scrollCart